/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preview_No_Event_SelectedInputs */

const en_video_export_preview_no_event_selected = /** @type {(inputs: Video_Export_Preview_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No event selected for preview`)
};

const fr_video_export_preview_no_event_selected = /** @type {(inputs: Video_Export_Preview_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun evenement selectionne pour la previsualisation`)
};

const de_video_export_preview_no_event_selected = /** @type {(inputs: Video_Export_Preview_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für die Vorschau wurde kein Ereignis ausgewählt.`)
};

const it_video_export_preview_no_event_selected = /** @type {(inputs: Video_Export_Preview_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun evento selezionato per l'anteprima`)
};

const ru_video_export_preview_no_event_selected = /** @type {(inputs: Video_Export_Preview_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для предварительного просмотра не выбрано ни одного события.`)
};

const es_video_export_preview_no_event_selected = /** @type {(inputs: Video_Export_Preview_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay ningún evento seleccionado para la vista previa`)
};

const zh_cn2_video_export_preview_no_event_selected = /** @type {(inputs: Video_Export_Preview_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未选择任何事件进行预览`)
};

const ja_video_export_preview_no_event_selected = /** @type {(inputs: Video_Export_Preview_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレビューにイベントが選択されていません`)
};

const hi_video_export_preview_no_event_selected = /** @type {(inputs: Video_Export_Preview_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्वावलोकन के लिए कोई इवेंट चयनित नहीं है`)
};

const pt_pt2_video_export_preview_no_event_selected = /** @type {(inputs: Video_Export_Preview_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum evento selecionado para pré-visualização.`)
};

/**
* | output |
* | --- |
* | "No event selected for preview" |
*
* @param {Video_Export_Preview_No_Event_SelectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preview_no_event_selected = /** @type {((inputs?: Video_Export_Preview_No_Event_SelectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preview_No_Event_SelectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_preview_no_event_selected(inputs)
	if (locale === "de") return de_video_export_preview_no_event_selected(inputs)
	if (locale === "it") return it_video_export_preview_no_event_selected(inputs)
	if (locale === "ru") return ru_video_export_preview_no_event_selected(inputs)
	if (locale === "es") return es_video_export_preview_no_event_selected(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_preview_no_event_selected(inputs)
	if (locale === "ja") return ja_video_export_preview_no_event_selected(inputs)
	if (locale === "hi") return hi_video_export_preview_no_event_selected(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_preview_no_event_selected(inputs)
	return en_video_export_preview_no_event_selected(inputs)
});